import * as assert from 'assert';

export const isNotNullOrWhitespace = (s?: string) => {
    return s && s.trim() !== '';
};

export function parseIntWithAssert(text: string | undefined): number | undefined {
    if (!text) {
        return undefined;
    }

    const trimmed = text.trim();
    console.assert(/^\d+$/.exec(trimmed), `Not-fully-numeric string passed to parseIntWithAssert: '${text}'`);
    const parsed = parseInt(trimmed);

    if (isNaN(parsed)) {
        return undefined;
    }

    return parsed;
}

export function assertIsString(x: unknown): x is string {
    const isString = typeof x === 'string';
    assert(isString, `Value passed to assertIsString wasn't: ${x}`);
    return isString;
}



// WEBPACK FOOTER //
// ./src/util/string.utils.ts